const isNumeric = (n: number | string) => String(n).length > 0 && !Number.isNaN(+n);

export { isNumeric };
